import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { MeService } from '../services/me.service';

/**
 * Restricts a route to the development user (bootstrap admin). Used to gate the control center
 * — permisos, roles, menús y tenant — so only `isBootstrapAdmin` users can view/edit them.
 * Non-dev users are redirected to home. The API still enforces this server-side.
 */
export const devOnlyGuard: CanActivateFn = () => {
  const me = inject(MeService);
  const router = inject(Router);

  return me.ensureLoaded().pipe(
    map(() => (me.isBootstrapAdmin() ? true : router.createUrlTree(['/'])))
  );
};
